import React, { useState, useEffect } from "react";
import KidsGalleryImg from "../assets/KidsGallery.svg";
import FunAdvImg from "../assets/FunAdv.svg";
import EventImg from "../assets/EventsCelebration.svg";
import useProfile from "../customHooks/useProfile";
import { GiGraduateCap } from "react-icons/gi";
import { FaAddressCard } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import axiosStrapiInstance from "../axiosStrapi";
import { baseUrl } from "../axiosStrapi";
import moment from "moment";
import CrabGif from "../assets/crab.gif";
import { toast } from "react-toastify";
import { CiBellOn } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import heartGif from "../assets/heartgif.gif";

export default function Dashboard() {
  const [notifications, setNotifications] = useState([]);
  const [posts, setPosts] = useState([]);
  const { userDetails } = useProfile();
  const allNotifications = notifications;

  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0,20);
    const fetchData = async () => {
      try {
        const dbQuery = [
          { apiName: "Posts", api: `/api/posts?filters[$or][1][$and][0][level][$eq]=Class&filters[$or][1][$and][1][class][class][$eq]=${userDetails?.class?.class}&sort=createdAt:asc&populate=*` },
          { apiName: "Notifications", api: `/api/notifications?filters[$or][0][level][$eq]=School&filters[$or][1][$and][0][level][$eq]=Class&filters[$or][1][$and][1][class][class][$eq]=${userDetails?.class?.class}&sort=createdAt:asc` },
        ];

        const result = await Promise.allSettled(
          dbQuery.map((item) =>
            axiosStrapiInstance.get(item.api, { privateToken: true })
          )
        );

        // Log errors for failed requests
        result.forEach((res, index) => {
          if (res.status === "rejected") {
            toast.error(`Error in fetching ${dbQuery[index]?.apiName}`);
            console.log(`Error in API call ${dbQuery[index]}:`, res.reason);
          }
        });

        // Update state only for successful requests
        setPosts(
          result[0]?.status === "fulfilled" ? result[0]?.value?.data?.data : []
        );
        setNotifications(
          result[1]?.status === "fulfilled" ? result[1]?.value?.data?.data : []
        );
      } catch (error) {
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, []);

  function deleteNotifications(id) {
    setNotifications((prev) => prev?.filter((item) => item?.id !== id));
    toast.success("Notification Removed")
  }



  return (
    <div className="bg-pink-50 font-Lato lg:max-h-[calc(100vh-80px)] overflow-y-hidden ">
      <div className="grid grid-cols-8 lg:grid-cols-12 ">
        {/* Profile Sidebar */}
        <div className="col-span-8 sm:col-span-3 bg-white">
          {/* upper section */}
          <div className="h-[30vh]  p-4 flex mt-4 flex-col gap-7 items-between justify-between border-b border-[#C2C2C2] text-center mb-6">
            <div className="flex justify-center px-[6%] items-center gap-3">
              <img
                src={`${userDetails?.image?.url}`}
                alt="Profile"
                className="rounded-full border-[10px] border-[#FDBE60] w-[88px] h-[88px] mb-2"
              />
              <div className="text-black flex flex-col items-start font-medium gap-2">
                <h2 className="text-4xl leading-[42px] ">
                  {userDetails?.fullName}
                </h2>
                <p className="text-base  leading-5 text-gray-500">
                  {userDetails?.class?.class}{" "} {userDetails?.class?.section}
                </p>
              </div>
            </div>
            <div className="flex pb-3 justify-center gap-10 items-center mb-4">
              <div className="text-center flex gap-3">
                <GiGraduateCap className="bg-[#E8E8E8] px-2 py-[2px] h-[44px] w-[44px] rounded-full" />
                <div className="text-left">
                  <p className="text-lg leading-7 font-medium">
                    {userDetails?.rollNo}
                  </p>
                  <p className="font-medium leading-5  text-base text-[#646464]">
                    Roll No
                  </p>
                </div>
              </div>
              <div className="text-center flex gap-3">
                <FaAddressCard className="bg-[#E8E8E8]  py-[2px] px-[10px] h-[44px] w-[44px] rounded-full" />
                <div className="text-left">
                  <p className="text-lg leading-7 font-medium">
                    {userDetails?.admissionNumber}
                  </p>
                  <p className="font-medium leading-5  text-base text-[#646464]">
                    Admission No
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* lower Section */}
          <div className="scrollbar-hidden overflow-y-scroll space-y-4 px-4 pb-4 h-[68vh] max-h-[56vh]">
            <div className="flex justify-center items-center gap-2">
              <div>
                <h3 className=" p-0 m-0 text-2xl lg:text-4xl leading-10 font-semibold">
                  My Gallery
                </h3>
                <button
                  className="mt-1 text-base text-[#646464] leading-5 font-medium"
                  onClick={() => navigate("/myGallery")}
                >
                  View all {`>`}
                </button>
              </div>
              <img
                src="./crazyEyes.gif"
                alt="crazy eyes"
                className="h-[112px] w-[112px]"
              />
            </div>
            <div className="bg-[#D2E2E1]  rounded-2xl p-3">
              <img
                src={FunAdvImg}
                alt="Gallery"
                className="rounded-lg mb-2 w-full"
              />
              <h4 className="text-[40px] text-center font-medium leading-[48px] text-black">
                Fun & Adventure
              </h4>
              <button
                className="mt-3 mb-4 px-3 lg:ml-[33%] ml-[25%]  py-[6px] border border-black rounded-[100px] text-black leading-5 font-semibold"
                onClick={() => navigate("/myGallery")}
              >
                VIEW ALL
              </button>
            </div>
            <div className="bg-[#EEC8E6]  rounded-2xl p-3">
              <img
                src={EventImg}
                alt="Gallery"
                className="rounded-lg mb-2 w-full"
              />
              <h4 className="text-[40px] text-center font-medium leading-[48px] text-black">
                Events & Celebration
              </h4>
              <button
                className="mt-3 mb-4 px-3 lg:ml-[33%] ml-[25%]  py-[6px] border border-black rounded-[100px] text-black leading-5 font-semibold"
                onClick={() => navigate("/myGallery")}
              >
                VIEW ALL
              </button>
            </div>
            <div className="bg-orange-300  rounded-2xl p-3">
              <img
                src={KidsGalleryImg}
                alt="Gallery"
                className="rounded-lg mb-2 w-full"
              />
              <h4 className="text-[40px] text-center font-medium leading-[48px] text-black">
                Kids Gallery
              </h4>
              <button
                className="mt-3 mb-4 px-3 lg:ml-[33%] ml-[25%]  py-[6px] border border-black rounded-[100px] text-black leading-5 font-semibold"
                onClick={() => navigate("/myGallery")}
              >
                VIEW ALL
              </button>
            </div>
          </div>
        </div>

        {/* Recently Added Section */}
        <div className="col-span-8 scrollbar-hidden h-[calc(100vh-77px)] overflow-y-scroll sm:col-span-5 bg-white shadow p-4 border-l border-r border-[#C2C2C2]">
          <h3 className="mb-4 font-semibold leading-[48px] text-center text-[40px]">
            Recently added{" "}
            <img
              src="./bird.gif"
              alt="bird"
              className=" inline mb-2  h-8 w-8"
            />
          </h3>
          <div className="space-y-4 px-[4%] mt-[10%] ">
            {posts.map((item) => (
              <div
                key={item}
                className="border max-h-[400px] border-[#C2C2C2] rounded-[20px] p-[10px] flex flex-col items-center"
              >
                {item?.media?.url.includes(".mp4") ? (
                  <video
                    src={`${baseUrl}${item?.media?.url}`}
                    alt="Video Thumbnail"
                    typeof="video/mp4"
                    controls
                    className="rounded-lg w-full max-h-[284px] object-cover h-[55%]"
                  />
                ) : (
                  <img
                    src={`${baseUrl}${item?.media?.url}`}
                    alt="Video Thumbnail"
                    typeof="video/mp4"
                    controls
                    className="rounded-lg w-full max-h-[284px] object-cover h-[55%]"
                  />
                )}

                <div className="flex flex-col w-full gap-3">
                  <h4 className="text-sm font-semibold mt-3 mb-2">
                    {item?.title}
                  </h4>
                  <p className="text-xs self-end bg-[#F2F2F2] px-[6px] py-1 w-fit rounded-xl">
                    {moment(item?.publishedAt).format("DD/MM/YYYY")}
                  </p>
                </div>
              </div>
            ))}

            <div className="w-full flex justify-center gap-4 p-[10px] items-center bg-[#FFB0C5] border border-[#C2C2C2] rounded-xl ">
              <p className="font-Lato font-bold text-[20px] leading-6 text-[#EF295F]">
                You've reached the end
              </p>
              <img src={CrabGif} alt="crab" className="h-[69px] w-[99px]" />
            </div>
          </div>
        </div>

        {/* Notifications Section */}
        <div className="col-span-8 scrollbar-hidden overflow-y-scroll max-h-[calc(100vh-80px)] font-Lato lg:col-span-4 bg-white shadow p-4">
          <div className="flex flex-col justify-center items-center mb-4 gap-4 ">
            <h3 className="text-[40px] text-black leading-[48px] font-bold">
              My Notification{" "}
              <CiBellOn className="h-[48px] pb-1 w-[48px] inline" />
            </h3>
            <button className="self-end border border-[#C2C2C2] py-1 px-[10px] rounded-3xl font-normal text-base leading-5 text-[#1A1A1A] ">
              Latest <IoIosArrowDown className="inline ml-1" />
            </button>
          </div>
          <div className="space-y-4">
            {notifications.map((item, index) => (
              <div
                key={index}
                className={`rounded-lg p-3 ${
                  index % 2 === 0 ? "bg-[#D2E2E1]" : "bg-[#EEC8E6]"
                }`}
              >
                <div className="flex justify-between items-center">
                  <p className="bg-[#FFFFFF73] rounded-xl text-black font-medium px-2 py-1 text-xs leading-4 ">
                    {moment(item?.publishedAt).format("DD/MM/YYYY")}
                  </p>
                  <RiDeleteBin6Line
                    className="rounded-full bg-[#FFFFFF73] cursor-pointer p-1 h-7 w-7 text-black"
                    onClick={() => deleteNotifications(item?.id)}
                  />
                </div>
                <p className="text-xl leading-6 font-bold mt-[50px]">
                  {item?.ttile}
                </p>
                <p className="text-base text-black mt-1 mb-3 leading-5">
                  {item?.description}
                </p>
              </div>
            ))}
            <div className="flex justify-center items-center sm:gap-4 bg-[#FFB0C5] border border-[#C2C2C2] rounded-lg">
              <p className="text-[#EF295F] font-bold text-xl  leading-6">
                You've reached the end
              </p>
              <img
                src={heartGif}
                alt="heart"
                className="sm:w-[80px] w-[60px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
